import React from 'react';
import { motion } from 'framer-motion';

const pricingList = [
  { name: "Gratis konsultation", price: "Kostnadsfri" },
  { name: "Hälsostart", price: "3 995 kr" },
  { name: "Styrka & Balans", price: "10 995 kr" },
  { name: "Livsstilsförändring Premium", price: "19 995 kr" },
  { name: "PT-pass", price: "1 095 kr" },
  { name: "5 PT-pass", price: "5 295 kr" },
  { name: "10 PT-pass", price: "9 995 kr" },
  { name: "Kostprogram", price: "Från 2 495 kr" },
  { name: "Träningsprogram", price: "Från 1 995 kr" }
];

const Pricing = () => {
  return (
    <section id="priser" className="py-24 bg-[#FAFAFA]">
      <div className="container mx-auto px-6 md:px-12 max-w-4xl">
        <div className="text-center mb-16">
          <span className="block text-xs uppercase tracking-[0.2em] text-stone-500 mb-4">
            Investering
          </span>
          <h2 className="text-3xl md:text-5xl font-medium mb-6 font-serif text-stone-900">
            Prislista
          </h2>
        </div>

        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="bg-white border border-stone-200 p-8 md:p-12 shadow-sm"
        >
          <div className="flex justify-between border-b-2 border-stone-900 pb-4 mb-6">
            <span className="font-serif text-lg font-medium">Tjänst</span>
            <span className="font-serif text-lg font-medium">Pris</span>
          </div>
          
          <ul className="space-y-4">
            {pricingList.map((item, index) => (
              <li 
                key={index} 
                className="flex justify-between items-center py-3 border-b border-stone-100 last:border-0 hover:bg-stone-50 transition-colors px-2 rounded-sm"
              >
                <span className="font-light text-stone-700">{item.name}</span>
                <span className="font-medium text-stone-900">{item.price}</span>
              </li>
            ))}
          </ul>

          <div className="mt-12 text-center">
            <p className="text-sm text-stone-500 font-light mb-6">
              Alla priser är inklusive moms. För företag gäller andra avtal och priser.
            </p>
            <a 
              href="mailto:hej@starkaremeddiana.se?subject=Bokningsförfrågan"
              className="inline-block px-10 py-4 bg-stone-900 text-white text-xs uppercase tracking-widest hover:bg-stone-800 transition-colors"
            >
              Kontakta mig för bokning
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Pricing;